import React from 'react';
import { Map, Marker } from '@vis.gl/react-google-maps';
import ornament from '../img/ornament.png';

const CallejoneadaSection: React.FC = () => {
  const mapContainerStyle = {
    width: '100%',
    height: '250px',
  };

  const center = {
    lat: 20.909501, // Latitude for Parque Benito Juarez
    lng: -100.743508, // Longitude for Parque Benito Juarez
  };
  const markerPosition = {
    lat: 20.909501, // Same latitude as center
    lng: -100.743508, // Same longitude as center
  };
  const handleMarkerClick = () => {
    const googleMapsUrl = `https://maps.app.goo.gl/XR5Ghzy5YFhiyTqf6`;
    window.open(googleMapsUrl, '_blank'); // Open the link in a new tab
  };

  return (
    <>
      <section id="callejoneada" className="bg-[#F7F4EF] text-center p-8">
        {/* Title */}
        <h2 className="text-title text-[#609966]">LA CALLEJONEADA</h2>
        {/* Separator */}
        <div className="mt-4">
          <img
            src={ornament}
            alt="Ornament"
            className="mx-auto transform scale-x-[1] ornament-size h-auto "
          />
        </div>
        {/* Date, Time, and Location */}
        <div className="mt-8">
          <p className="text-md italic text-gray-400">¿Cuándo?</p>
          <p className="text-lg text-gray-500 mt-2 mb-8">14 de Marzo de 2025</p>
          <p className="text-mg italic text-gray-400 mt-4">¿A qué hora?</p>
          <p className="text-lg text-gray-500 mt-2 mb-8">6:00 PM</p>
          <p className="text-md italic text-gray-400 mt-4">¿Dónde?</p>
          <p
            className="text-lg text-gray-500 mt-2 mb-8 underline"
            onClick={handleMarkerClick}
          >
            Parque Benito Juárez, San Miguel de Allende
          </p>
          <p className="text-md italic text-gray-400 mt-4">
            Codigo de Vestimenta
          </p>
          <p className="text-lg text-gray-500 mt-2">Casual</p>
        </div>
      </section>
      <div className="shadow-y-only-inset">
        <Map
          onClick={handleMarkerClick}
          center={center}
          defaultZoom={14}
          style={mapContainerStyle}
        >
          <Marker position={markerPosition} />
        </Map>
      </div>
    </>
  );
};

export default CallejoneadaSection;
